<template>
  <div class="logo" :style="{ height: size }">
    <img
      class="logo__icon"
      v-if="type === 'shield'"
      src="@/assets/icons/lsmu-shield.svg"
      alt=""
    />
    <img
      class="logo__icon"
      v-if="type === 'white'"
      src="@/assets/icons/lsmu-logo-white.svg"
      alt=""
    />
    <img
      class="logo__icon"
      v-if="type === 'black'"
      src="@/assets/icons/lsmu-logo-black.svg"
      alt=""
    />
  </div>
</template>

<script>
import LogoTypes from "./LogoTypes";

export default {
  name: "Logo",
  props: {
    type: {
      type: String,
      default: LogoTypes.SHIELD
    },
    size: {
      type: String,
      default: "40px"
    }
  }
};
</script>

<style lang="scss" scoped>
.logo {
  display: block;

  &__icon {
    height: 100%;
  }
}
</style>
